import { computed } from 'vue';
import { mapVisibleModulesToNavigation } from './mapVisibleTreeToNavigation';
import { useVisibleDirectoryTree } from './useVisibleDirectoryTree';

export function useModules() {
  const { tree, loading, hasError, load } = useVisibleDirectoryTree({ autoLoad: true });

  const modules = computed(() => mapVisibleModulesToNavigation(tree.value));
  const error = computed(() => (hasError.value ? 'Erro ao carregar módulos' : null));

  const fetchModules = async () => {
    await load().catch(() => undefined);
  };

  return {
    modules,
    loading,
    error,
    fetchModules,
  };
}
